<template>
    <PanelItem :index="index" :field="field">
        <template #value>
            <div v-if="images.length" class="grid grid-cols-2 gap-3 md:grid-cols-4">
                <div
                    v-for="(image, index) in images"
                    :key="index"
                    class="relative overflow-hidden rounded-xl border border-zinc-200/80 dark:border-zinc-700"
                >
                    <img
                        :src="image.url"
                        :alt="__('Product image')"
                        class="aspect-[4/3] w-full object-cover"
                    >
                    <span
                        v-if="index === 0"
                        class="absolute start-2 top-2 rounded bg-yellow-400 px-2 py-0.5 text-[10px] font-bold text-yellow-950"
                    >
                        {{ __('Cover') }}
                    </span>
                </div>
            </div>
            <span v-else>&mdash;</span>
        </template>
    </PanelItem>
</template>

<script>
export default {
    props: ['index', 'resource', 'resourceName', 'resourceId', 'field'],

    computed: {
        /**
         * Images rendered on the detail panel.
         *
         * @returns {Array<{url: string}>}
         */
        images() {
            return this.field.initialImages || []
        },
    },
}
</script>
